import React from 'react';
import DashboardCard from '../shared/DashboardCard';
import styles from '../../../../styles/DashboardV2.module.css';

interface ListingsHealthWidgetProps {
    activeCount: number;
    incompleteCount: number;
    healthScore: number;
    loading?: boolean;
}

const ListingsHealthWidget: React.FC<ListingsHealthWidgetProps> = ({
    activeCount,
    incompleteCount,
    healthScore,
    loading,
}) => {
    const healthVariant = healthScore >= 90 ? 'green' : healthScore >= 70 ? 'amber' : 'red';

    return (
        <DashboardCard
            title="Listings Health"
            loading={loading}
        >
            <div className={styles.statGrid}>
                <div className={styles.statItem}>
                    <div className={`${styles.statItemValue} ${styles.statItemValueGreen}`}>
                        {activeCount}
                    </div>
                    <div className={styles.statItemLabel}>Active</div>
                </div>
                <div className={styles.statItem}>
                    <div className={`${styles.statItemValue} ${incompleteCount > 0 ? styles.statItemValueAmber : styles.statItemValueGreen}`}>
                        {incompleteCount}
                    </div>
                    <div className={styles.statItemLabel}>Incomplete</div>
                </div>
            </div>
            <div className={`${styles.healthScore}`} style={{
                background: healthScore >= 90 ? '#f0fdf4' : healthScore >= 70 ? '#fffbeb' : '#fef2f2',
                border: `1px solid ${healthScore >= 90 ? '#bbf7d0' : healthScore >= 70 ? '#fde68a' : '#fecaca'}`,
            }}>
                <span className={styles.healthScoreLabel} style={{
                    color: healthScore >= 90 ? '#15803d' : healthScore >= 70 ? '#92400e' : '#991b1b',
                }}>
                    Overall Health
                </span>
                <span className={styles.healthScoreValue} style={{
                    color: healthScore >= 90 ? '#16a34a' : healthScore >= 70 ? '#d97706' : '#dc2626',
                }}>
                    {healthScore.toFixed(0)}%
                </span>
            </div>
        </DashboardCard>
    );
};

export default ListingsHealthWidget;
